
export default () => {
  return window.location.hash.slice(1)
}
